import React, { useState } from "react";

import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { faCircle, faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ITableActiveFilter } from "./Interfaces";

interface IProps {
  filterKey: string;
  label: string;
  active: boolean;
  columnIndex: number;
  setActive: (clickedFilter: ITableActiveFilter) => void;
  disabled?: boolean;
}

export const ZeosFilterButton = (props: IProps) => {
  const [hovered, setHovered] = useState(false);

  const styles = props.disabled
    ? "border-zeos-grey-md bg-gray-100 text-gray-400 cursor-not-allowed"
    : props.active
    ? "border-zeos-orange-md bg-orange-100 text-zeos-black hover:bg-orange-200"
    : "border-zeos-grey-md text-zeos-grey-md hover:bg-gray-100";

  const icon = props.disabled
    ? faCircle
    : props.active
    ? faCircleXmark
    : faCirclePlus;

  const filter = {
    filterKey: props.filterKey,
    columnIndex: props.columnIndex,
    value: props.label,
  };
  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <button
        className={`mr-2 inline-flex items-center gap-1 rounded-2 px-3 py-1 text-sm border-2 ${styles}`}
        onClick={() => props.setActive(filter)}
        disabled={props.disabled}
      >
        {props.label}
        <span className="text-xs">
          <FontAwesomeIcon icon={icon} />
        </span>

        {props.disabled && hovered && (
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 z-10 w-64 bg-gray-800 text-white text-sm p-2 rounded shadow-lg text-left">
            No matching data available for this filter.
          </div>
        )}
      </button>
    </div>
  );
};
